import moment from "moment";

export const generateCartesianMockData = (days: number, maxValue: number) => {
	const data = [];
	let date = moment().utc().subtract(days, "day");
	let i = 0;
	while (i < days) {
		data.push({ date: date.format("YYYY-MM-DD"), value: Math.floor(Math.random() * maxValue) });
		date = date.add(1, "day");
		i++;
	}
	return data;
};

export const generatePieMockData = () => {
	// The names here doesn't matter because they don't appear
	// On the mocked chart
	return [
		{
			name: "a",
			value: Math.floor(Math.random() * 100),
		},
		{
			name: "b",
			value: Math.floor(Math.random() * 100),
		},
		{
			name: "c",
			value: Math.floor(Math.random() * 100),
		},
	];
};
